// extracted by mini-css-extract-plugin
module.exports = {"personalBase":"styles_personalBase__2M5Hx","pageTitle":"styles_pageTitle__3WRnV","pageHeader":"styles_pageHeader__7JCc-","rightContent":"styles_rightContent__171vf"};